'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import { LocateIcon } from 'lucide-react';
import { LazyImage } from '@/components/partials';
import { ProductOemType } from '@/types/product';
type PropsType = {
  oemNumbers: ProductOemType[];
  // When set, the row's matching OEM chip is highlighted.
  selectedOem?: ProductOemType;
  // Base product detail path (locale-less); OEM chips link to `${oemBaseHref}/brand/model/oem`.
  oemBaseHref: string;
};
type BrandModelRow = {
  key: string;
  brandName: string;
  brandPicture?: {
    path: string;
  };
  modelName: string;
  oemNumbers: ProductOemType[];
};
const ProductOemNumbersSection = t0 => {
  const $ = _c(32);
  const {
    oemNumbers,
    selectedOem,
    oemBaseHref
  } = t0;
  const t = useTranslations();
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== oemBaseHref || $[1] !== oemNumbers || $[2] !== selectedOem?.model || $[3] !== selectedOem?.slug || $[4] !== t) {
    const rows = [];
    const rowMap = new Map();
    oemNumbers.forEach(oem => {
      const key = `${oem.model.brand.id}/${oem.model.id}`;
      let row = rowMap.get(key);
      if (!row) {
        row = {
          key,
          brandName: oem.model.brand.name,
          brandPicture: oem.model.brand.picture,
          modelName: oem.model.name,
          oemNumbers: []
        };
        rowMap.set(key, row);
        rows.push(row);
      }
      if (!row.oemNumbers.some(o => o.slug === oem.slug)) {
        row.oemNumbers.push(oem);
      }
    });
    const isActiveOem = oem_0 => oem_0.model.brand.slug === selectedOem?.model.brand.slug && oem_0.model.slug === selectedOem?.model.slug && oem_0.slug === selectedOem?.slug;
    t3 = "overflow-x-auto rounded-md border";
    t1 = "w-full text-left text-sm";
    let t5;
    if ($[9] !== t) {
      t5 = t("brand");
      $[9] = t;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t5) {
      t6 = <th className="px-4 py-3">{t5}</th>;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] !== t) {
      t7 = t("model");
      $[13] = t;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== t7) {
      t8 = <th className="px-4 py-3">{t7}</th>;
      $[15] = t7;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== t) {
      t9 = t("oem_no");
      $[17] = t;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== t9) {
      t10 = <th className="px-4 py-3">{t9}</th>;
      $[19] = t9;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    if ($[21] !== t10 || $[22] !== t6 || $[23] !== t8) {
      t2 = <thead><tr className="bg-neutral-800 text-xs font-semibold tracking-wide text-white uppercase">{t6}{t8}{t10}</tr></thead>;
      $[21] = t10;
      $[22] = t6;
      $[23] = t8;
      $[24] = t2;
    } else {
      t2 = $[24];
    }
    t4 = <tbody>{rows.map((row_0, index) => <tr key={row_0.key} className={row_0.oemNumbers.some(isActiveOem) ? "bg-yellow-50" : index % 2 === 0 ? "bg-white" : "bg-gray-50"}><td className="px-4 py-3 align-top font-semibold whitespace-nowrap text-gray-800"><div className="flex items-center gap-2">{row_0.brandPicture ? <span className="relative flex h-6 w-6 shrink-0 items-center justify-center overflow-hidden rounded-md"><LazyImage src={`/api/shared/media/picture/24/24/${row_0.brandPicture.path}`} alt={row_0.brandName} width={24} height={24} className="h-5 w-5 object-contain" /></span> : <LocateIcon className="h-4 w-4 shrink-0 text-gray-500" />}{row_0.brandName}</div></td><td className="px-4 py-3 align-top text-gray-700">{row_0.modelName}</td><td className="px-4 py-3 align-top"><div className="flex flex-wrap gap-x-3 gap-y-1.5">{row_0.oemNumbers.map(oem_1 => {
              const active = isActiveOem(oem_1);
              return <Link key={oem_1.slug} href={`${oemBaseHref}/${oem_1.model.brand.slug}/${oem_1.model.slug}/${oem_1.slug}`} className={`rounded px-1.5 text-sm transition-colors ${active ? "bg-brand font-semibold text-white" : "hover:bg-brand/20 bg-gray-100 text-gray-800"}`}>{oem_1.oem}</Link>;
            })}</div></td></tr>)}</tbody>;
    $[0] = oemBaseHref;
    $[1] = oemNumbers;
    $[2] = selectedOem?.model;
    $[3] = selectedOem?.slug;
    $[4] = t;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[25] !== t1 || $[26] !== t2 || $[27] !== t4) {
    t5 = <table className={t1}>{t2}{t4}</table>;
    $[25] = t1;
    $[26] = t2;
    $[27] = t4;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  let t6;
  if ($[29] !== t3 || $[30] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[29] = t3;
    $[30] = t5;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
};
export default ProductOemNumbersSection;